import React from "react";
import { Link, Location } from "react-router-dom";
import { Home, Compass, ShoppingBag, User } from "lucide-react";
import { BottomNavItem } from "../types";

interface MobileBottomNavProps {
  location: Location;
  onAccountClick: () => void; // nouvelle prop
}

const bottomNavItems: Omit<BottomNavItem, "onClick">[] = [
  { icon: Home, label: "Accueil", path: "/" },
  { icon: Compass, label: "Explorer", path: "/explorer" },
  { icon: ShoppingBag, label: "Panier", path: "/cart" },
  // Le compte n'a plus de path, il déclenche un onClick
];

const MobileBottomNav: React.FC<MobileBottomNavProps> = ({ location, onAccountClick }) => {
  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t shadow-lg">
      <div className="flex justify-around items-center h-14">
        {bottomNavItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center w-full h-full relative ${
                isActive ? "text-primary" : "text-gray-600"
              }`}
            >
              <item.icon className="w-5 h-5 mb-1" />
              <span className="text-xs font-medium">{item.label}</span>
              {isActive && (
                <div className="absolute top-0 w-12 h-0.5 bg-primary rounded-b-full" />
              )}
            </Link>
          );
        })}

        {/* Bouton "Compte" personnalisé (pas un Link) */}
        <button
          onClick={onAccountClick}
          className="flex flex-col items-center justify-center w-full h-full relative text-gray-600 hover:text-primary transition-colors"
        >
          <User className="w-5 h-5 mb-1" />
          <span className="text-xs font-medium">Compte</span>
        </button>
      </div>
    </nav>
  );
};

export default MobileBottomNav;